var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { ctmApi } from "../api.js";
import { CTM_TAGS } from "../common.js";
const computeTaskApi = ctmApi.injectEndpoints({
  endpoints: (builder) => ({
    queryComputeTasks: builder.query({
      query: (payload) => {
        const { workspaceId, computeName, skip, top, status, search } = payload;
        return {
          url: `/workspaces/${workspaceId}/compute/${computeName}/queueinfos`,
          method: "GET",
          params: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, skip != null && { skip }), top != null && { top }), status != null && { status }), search && { search })
        };
      },
      providesTags: (result, error, { computeName, workspaceId }) => [{ type: CTM_TAGS.COMPUTE_TASK, computeName, workspaceId }]
    })
  })
});
const { usePrefetch: useComputeTaskApiPrefetch, useQueryComputeTasksQuery } = computeTaskApi;
export {
  computeTaskApi,
  useComputeTaskApiPrefetch,
  useQueryComputeTasksQuery
};
//# sourceMappingURL=compute-tasks.js.map
